import i18n from "@/i18n";

const routes = {
  path: "/support",
  name: "Support",
  component: () =>
    import(/* webpackChunkName: "support" */ "@/views/support/Main"),
  children: [
    {
      path: "palyernotice",
      alias: "",
      name: "PlayerNoticeList",
      component: () =>
        import(
          /* webpackChunkName: "support" */ "@/views/support/PlayerNoticeList"
        ),
      prop: true,
      meta: {
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.support.member_notice_list"),
        step: [
          i18n.t("page.support.support"),
          i18n.t("page.support.member_notice_list"),
        ],
        menu_num: 2,
        sub_menu_num: 21,
        location: "/support/palyernotice",
      },
    },
    {
      path: "palyernoticeview/:noticeno",
      name: "PlayerNoticeView",
      component: () =>
        import(
          /* webpackChunkName: "support" */ "@/views/support/PlayerNoticeView"
        ),
      prop: true,
      meta: {
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.support.member_notice_view"),
        step: [
          i18n.t("page.support.support"),
          i18n.t("page.support.member_notice_list"),
        ],
        menu_num: 2,
        sub_menu_num: 21,
        location: "/support/palyernotice",
      },
    },
    {
      path: "palyernoticewrite/:noticeno?",
      name: "PlayerNoticeWrite",
      component: () =>
        import(
          /* webpackChunkName: "support" */ "@/views/support/PlayerNoticeWrite"
        ),
      prop: true,
      meta: {
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.support.member_notice_write"),
        step: [
          i18n.t("page.support.support"),
          i18n.t("page.support.member_notice_list"),
        ],
        menu_num: 2,
        sub_menu_num: 21,
        location: "/support/palyernotice",
      },
    },
    {
      path: "ownernotice",
      name: "OwnerNoticeList",
      component: () =>
        import(
          /* webpackChunkName: "support" */ "@/views/support/OwnerNoticeList"
        ),
      prop: true,
      meta: {
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.support.owner_notice_list"),
        step: [
          i18n.t("page.support.support"),
          i18n.t("page.support.owner_notice_list"),
        ],
        menu_num: 2,
        sub_menu_num: 22,
        location: "/support/ownernotice",
      },
    },
    {
      path: "ownernoticeview/:noticeno",
      name: "OwnerNoticeView",
      component: () =>
        import(
          /* webpackChunkName: "support" */ "@/views/support/OwnerNoticeView"
        ),
      prop: true,
      meta: {
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.support.owner_notice_view"),
        step: [
          i18n.t("page.support.support"),
          i18n.t("page.support.owner_notice_list"),
        ],
        menu_num: 2,
        sub_menu_num: 22,
        location: "/support/ownernotice",
      },
    },
    {
      path: "ownernoticewrite/:noticeno?",
      name: "OwnerNoticeWrite",
      component: () =>
        import(
          /* webpackChunkName: "support" */ "@/views/support/OwnerNoticeWrite"
        ),
      prop: true,
      meta: {
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.support.owner_notice_write"),
        step: [
          i18n.t("page.support.support"),
          i18n.t("page.support.owner_notice_list"),
        ],
        menu_num: 2,
        sub_menu_num: 22,
        location: "/support/ownernotice",
      },
    },
    {
      path: "appnotice",
      name: "AppNoticeList",
      component: () =>
        import(
          /* webpackChunkName: "support" */ "@/views/support/AppNoticeList"
        ),
      prop: true,
      meta: {
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.support.app_notice_list"),
        step: [
          i18n.t("page.support.support"),
          i18n.t("page.support.app_notice_list"),
        ],
        menu_num: 2,
        sub_menu_num: 23,
        location: "/support/appnotice",
      },
    },
    {
      path: "appnoticeview/:noticeno",
      name: "AppNoticeView",
      component: () =>
        import(
          /* webpackChunkName: "support" */ "@/views/support/AppNoticeView"
        ),
      prop: true,
      meta: {
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.support.app_notice_view"),
        step: [
          i18n.t("page.support.support"),
          i18n.t("page.support.app_notice_list"),
        ],
        menu_num: 2,
        sub_menu_num: 23,
        location: "/support/appnotice",
      },
    },
    {
      path: "appnoticewrite/:noticeno?",
      name: "AppNoticeWrite",
      component: () =>
        import(
          /* webpackChunkName: "support" */ "@/views/support/AppNoticeWrite"
        ),
      prop: true,
      meta: {
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.support.app_notice_write"),
        step: [
          i18n.t("page.support.support"),
          i18n.t("page.support.app_notice_list"),
        ],
        menu_num: 2,
        sub_menu_num: 23,
        location: "/support/appnotice",
      },
    },
    {
      path: "resources",
      name: "ResourcesList",
      component: () =>
        import(
          /* webpackChunkName: "support" */ "@/views/support/ResourcesList"
        ),
      prop: true,
      meta: {
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.support.resources_list"),
        step: [
          i18n.t("page.support.support"),
          i18n.t("page.support.resources_list"),
        ],
        menu_num: 2,
        sub_menu_num: 24,
        location: "/support/resources",
      },
    },
    {
      path: "resourcesview/:resourcesno",
      name: "ResourcesView",
      component: () =>
        import(
          /* webpackChunkName: "support" */ "@/views/support/ResourcesView"
        ),
      prop: true,
      meta: {
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.support.resources_view"),
        step: [
          i18n.t("page.support.support"),
          i18n.t("page.support.resources_list"),
        ],
        menu_num: 2,
        sub_menu_num: 24,
        location: "/support/resources",
      },
    },
    {
      path: "resourceswrite/:resourcesno?",
      name: "ResourcesWrite",
      component: () =>
        import(
          /* webpackChunkName: "support" */ "@/views/support/ResourcesWrite"
        ),
      prop: true,
      meta: {
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.support.resources_write"),
        step: [
          i18n.t("page.support.support"),
          i18n.t("page.support.resources_list"),
        ],
        menu_num: 2,
        sub_menu_num: 24,
        location: "/support/resources",
      },
    },
    {
      path: "inquiry",
      name: "InquiryList",
      component: () =>
        import(/* webpackChunkName: "support" */ "@/views/support/InquiryList"),
      prop: true,
      meta: {
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.support.inquiry_list"),
        step: [
          i18n.t("page.support.support"),
          i18n.t("page.support.inquiry_list"),
        ],
        menu_num: 2,
        sub_menu_num: 25,
        location: "/support/inquiry",
      },
    },
    {
      path: "inquiryview/:inquiryno",
      name: "InquiryView",
      component: () =>
        import(/* webpackChunkName: "support" */ "@/views/support/InquiryView"),
      prop: true,
      meta: {
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.support.inquiry_view"),
        step: [
          i18n.t("page.support.support"),
          i18n.t("page.support.inquiry_list"),
        ],
        menu_num: 2,
        sub_menu_num: 25,
        location: "/support/inquiry",
      },
    },
  ],
};

export default routes;
